import {
  Component,
  Host,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BaseComponent } from '../base/base-component.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { HelperService } from '../services/helper.service';

@Component({
  standalone: false,
  selector: 'daui-dropdown-item',
  templateUrl: './dropdown-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./dropdown-item.component.less'],
})
export class DropdownItemComponent extends BaseComponent implements AfterViewInit {
  @Input() value: string;
  @ViewChild('contentWrapper', { static: false }) content: ElementRef;

  parent: DropdownComponent;
  isActive = false;

  constructor(
    @Host() parent: DropdownComponent,
    private helperService: HelperService,
  ) {
    super();
    this.parent = parent;
  }
  ngAfterViewInit() {
    if (this.helperService.isNullOrEmpty(this.value)) {
      console.log('\x1b[43mERROR: the property value of daui-dropdown-item is empty!');
      return;
    }
    this.parent.subscribeItem(this);
    if (!this.id) {
      this.id = this.parent.id;
    }
  }
  protected onInit(): void {}
  protected onDestroy(): void {
    this.parent.unsubscribeItem(this);
  }

  onClick() {
    this.parent.select(this);
  }
}
